import { List, ListItem, Popover, styled } from '@mui/material';

export const RoundedPopover = styled(Popover)(() => ({
  '& span': {
    fontSize: '15px',
  },
}));

export const popoverLeftProperties = {
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'left' as const,
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'left' as const,
  },
  slotProps: {
    paper: {
      sx: {
        marginLeft: '30px',
        marginTop: '0px',
        borderRadius: '12px',
      },
    },
  },
};

export const popoverRightProperties = {
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'right' as const,
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'right' as const,
  },
  slotProps: {
    paper: {
      sx: {
        marginLeft: '-6px',
        borderRadius: '12px',
      },
    },
  },
};

export const RoundedPopoverList = styled(List)(() => ({
  padding: 0,
}));

export const RoundedPopoverListItem = styled(ListItem)<{ selected?: boolean; disabled?: boolean }>(
  ({ theme, selected, disabled }) => ({
    padding: '12px 16px',
    cursor: (() => {
      if (selected) return 'default';
      if (disabled) return 'not-allowed';
      return 'pointer';
    })(),
    opacity: disabled ? 0.5 : 1,
    pointerEvents: disabled ? 'none' : 'auto',
    '&:hover': {
      backgroundColor: disabled ? 'transparent' : theme.palette.action.hover,
    },
    '& .MuiListItemIcon-root': {
      minWidth: 28,
      marginRight: 4,
    },
  })
);
